import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRedditComponent } from './simple-icons-reddit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRedditComponent ],
    exports:      [ SimpleIconsRedditComponent ],
    bootstrap:    []
})
export class SimpleIconsRedditModule {}
